<template>
	<modal
		:title="title"
		id="create_consent"
		cancel-label="Cancel"
		continue-label="Save changes"
		v-on:closed="cancel"
		v-on:confirm="saveChanges"
		:showModal="showModal"
	>
		<template v-slot:body>
			<form class="form-horizontal">
				<div class="form-group row" v-if="errors.length">
          <div class="alert alert-danger">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in errors">{{ error }}</li>
            </ul>
          </div>
	      </div>
		    <div v-for="(task, index) in tasks" class="row" :key="index">
	        <div class="col-sm-7 col-sm-offset-2">
            <input type="radio" :value="task.version" v-model="version" :id="'version-'+index">
            <label :for="'version-'+index">
               &nbsp;&nbsp;{{ task.version }} <span v-if="task.addendum"> &mdash; {{ task.addendum }}</span>
            </label>
	        </div>
		    </div>
  		</form>
		</template>
	</modal>
</template>

<script setup>
	import { ref, computed } from 'vue'
	import Modal from '../../Modal.vue'

	const props = defineProps(['consent', 'tasks', 'showModal'])
  const emit = defineEmits(['input', 'closed', 'confirm'])

	const version = ref(null)
	const errors = ref([])

	function saveChanges() {
		let validated = validateForm()
    if (validated) {
			let data = {}
			data.version = version.value
      data.consent_form_type_id = props.consent.id
			emit('confirm', data)
			emit('input', false)
		}
	}

	function cancel() {
		emit('closed')
		emit('input', false)
	}

	function validateForm() {
		if (version.value) {
	    return true
	  }
    if (!version.value) {
      errors.value.push("Task required.");
      return false
    }
	}
		
	const title = computed(() => {
		return "Assign Task for "+ props.consent.name
	})
</script>